import styled from "styled-components";

/** Groups inputs in a column */
const FieldGroup = styled.div`
    display: flex;
    ${props => props.flexDirection ? "flex-direction: " + props.flexDirection + ";" : "column;"}
    gap: 16px;
`;

export default FieldGroup;